import { useEffect } from "react";

/**
 * <OrganizationSchema> — site-wide Organization JSON-LD.
 *
 * Rendered inside the public <Layout>, so it appears on every public page but
 * NOT on admin routes, auth routes, funnels, or unknown-fallback pages served
 * by the base index.html.
 *
 * Effect-based (see comment in Seo.jsx) so the tag is stable across
 * prerender → hydration and never duplicates.
 */
const ATTR = "data-org-schema";

export default function OrganizationSchema() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.head.querySelectorAll(`script[${ATTR}]`).forEach((n) => n.remove());
    const data = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://swipetronics.com/#organization",
      name: "Swipetronics",
      url: "https://swipetronics.com/",
      logo: "https://swipetronics.com/brand/swipetronics-logo.png",
      description:
        "Swipetronics helps businesses reduce unnecessary processing costs, upgrade payment technology, and receive dependable merchant support.",
      telephone: "+1-877-794-7369",
      email: "info@swipetronics.com",
      areaServed: "US",
      knowsAbout: [
        "Merchant Services",
        "Card Processing",
        "POS Systems",
        "Payment Terminals",
        "Cash Discount Programs",
        "Mobile Payments",
        "E-Commerce Payment Processing",
      ],
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-877-794-7369",
        contactType: "customer service",
        email: "info@swipetronics.com",
        areaServed: "US",
        availableLanguage: ["English"],
      },
      sameAs: [
        "https://www.instagram.com/swipetronicspos/",
        "https://www.facebook.com/people/Swipetronics/61590748512790/",
        "https://www.linkedin.com/company/swipetronics/",
        "https://www.youtube.com/@swipetronics",
      ],
    };
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute(ATTR, "true");
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      // If Layout unmounts (private routes navigated to), remove the tag.
      document.head
        .querySelectorAll(`script[${ATTR}]`)
        .forEach((n) => n.remove());
    };
  }, []);
  return null;
}
